import theme from '../../../../assets/theme';

type Shape = {
  clipPath?: string;
  defaultColors: string[];
  width?: number;
  height?: number;
  name: string;
};
const rectangle = {
  clipPath: undefined,
  defaultColors: [theme.colors.greyDark],
  name: 'rectangle',
};
const borderRadiusRectangle = {
  clipPath: 'inset(0% 0% 0% 0% round 20px)',
  defaultColors: [theme.colors.greyDark],
  name: 'borderRadiusRectangle',
};
const polygon = {
  clipPath: 'polygon(50% 0, 100% 50%, 50% 100%, 0 50%)',
  defaultColors: [theme.colors.greyDark],
  name: 'polygon',
};
const halfCircle = {
  clipPath: 'ellipse(100% 50% at 0% 50%);',
  defaultColors: [theme.colors.greyDark],
  name: 'halfCircle',
};
const circle = {
  clipPath: 'ellipse(50% 50%);',
  defaultColors: [theme.colors.greyDark],
  name: 'circle',
};
const ellipse = {
  clipPath: 'ellipse(50% 50%);',
  defaultColors: [theme.colors.greyDark],
  name: 'ellipse',
  height: 50,
  width: 200,
};
const triangle = {
  clipPath: 'polygon(50% 0%, 0% 100%, 100% 100%);',
  defaultColors: [theme.colors.greyDark],
  name: 'triangle',
};
const trapezoid = {
  clipPath: 'polygon(20% 0%, 80% 0%, 100% 100%, 0% 100%);',
  defaultColors: [theme.colors.greyDark],
  name: 'trapezoid',
};
const parallelogram = {
  clipPath: 'polygon(25% 0%, 100% 0%, 75% 100%, 0% 100%);',
  defaultColors: [theme.colors.greyDark],
  name: 'parallelogram',
};
const rhombus = {
  clipPath: 'polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%);',
  defaultColors: [theme.colors.greyDark],
  name: 'rhombus',
};
const pentagon = {
  clipPath: 'polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%);',
  defaultColors: [theme.colors.greyDark],
  name: 'pentagon',
};
const hexagon = {
  clipPath: 'polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%);',
  defaultColors: [theme.colors.greyDark],
  name: 'hexagon',
};
const heptagon = {
  clipPath: 'polygon(50% 0%, 90% 20%, 100% 60%, 75% 100%, 25% 100%, 0% 60%, 10% 20%);',
  defaultColors: [theme.colors.greyDark],
  name: 'heptagon',
};
const octagon = {
  clipPath:
    'polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%);',
  defaultColors: [theme.colors.greyDark],
  name: 'octagon',
};
const nonagon = {
  clipPath:
    'polygon(50% 0%, 83% 12%, 100% 43%, 94% 78%, 68% 100%, 32% 100%, 6% 78%, 0% 43%, 17% 12%);',
  defaultColors: [theme.colors.greyDark],
  name: 'nonagon',
};
const decagon = {
  clipPath:
    'polygon(50% 0%, 80% 10%, 100% 35%, 100% 70%, 80% 90%, 50% 100%, 20% 90%, 0% 70%, 0% 35%, 20% 10%);',
  defaultColors: [theme.colors.greyDark],
  name: 'decagon',
};
const bevel = {
  clipPath:
    'polygon(20% 0%, 80% 0%, 100% 20%, 100% 80%, 80% 100%, 20% 100%, 0% 80%, 0% 20%);',
  defaultColors: [theme.colors.greyDark],
  name: 'bevel',
};
const rabbet = {
  clipPath:
    'polygon(0% 15%, 15% 15%, 15% 0%, 85% 0%, 85% 15%, 100% 15%, 100% 85%, 85% 85%, 85% 100%, 15% 100%, 15% 85%, 0% 85%);',
  defaultColors: [theme.colors.greyDark],
  name: 'rabbet',
};
const frame = {
  clipPath:
    'polygon(0% 0%, 0% 100%, 25% 100%, 25% 25%, 75% 25%, 75% 75%, 25% 75%, 25% 100%, 100% 100%, 100% 0%);',
  defaultColors: [theme.colors.greyDark],
  name: 'frame',
};
const star = {
  clipPath:
    'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);',
  defaultColors: [theme.colors.greyDark],
  name: 'star',
};
const message = {
  clipPath: 'polygon(0% 0%, 100% 0%, 100% 75%, 75% 75%, 75% 100%, 50% 75%, 0% 75%);',
  defaultColors: [theme.colors.greyDark],
  name: 'message',
};
const cross = {
  clipPath:
    'polygon(10% 25%, 35% 25%, 35% 0%, 65% 0%, 65% 25%, 90% 25%, 90% 50%, 65% 50%, 65% 100%, 35% 100%, 35% 50%, 10% 50%);',
  defaultColors: [theme.colors.greyDark],
  name: 'cross',
};
const leftArrow = {
  clipPath: 'polygon(40% 0%, 40% 20%, 100% 20%, 100% 80%, 40% 80%, 40% 100%, 0% 50%);',
  defaultColors: [theme.colors.greyDark],
  name: 'leftArrow',
};
const rightArrow = {
  clipPath: 'polygon(0% 20%, 60% 20%, 60% 0%, 100% 50%, 60% 100%, 60% 80%, 0% 80%);',
  defaultColors: [theme.colors.greyDark],
  name: 'rightArrow',
};
const leftPoint = {
  clipPath: 'polygon(25% 0%, 100% 0%, 100% 100%, 25% 100%, 0% 50%);',
  defaultColors: [theme.colors.greyDark],
  name: 'leftPoint',
};
const rightPoint = {
  clipPath: 'polygon(0% 0%, 75% 0%, 100% 50%, 75% 100%, 0% 100%)',
  defaultColors: [theme.colors.greyDark],
  name: 'rightPoint',
};
const leftChevron = {
  clipPath: 'polygon(100% 0%, 75% 50%, 100% 100%, 25% 100%, 0% 50%, 25% 0%)',
  defaultColors: [theme.colors.greyDark],
  name: 'leftChevron',
};
const rightChevron = {
  clipPath: 'polygon(75% 0%, 100% 50%, 75% 100%, 0% 100%, 25% 50%, 0% 0%);',
  defaultColors: [theme.colors.greyDark],
  name: 'rightChevron',
};
const crossOut = {
  clipPath:
    'polygon(20% 0%, 0% 20%, 30% 50%, 0% 80%, 20% 100%, 50% 70%, 80% 100%, 100% 80%, 70% 50%, 100% 20%, 80% 0%, 50% 30%)',
  defaultColors: [theme.colors.greyDark],
  name: 'crossOut',
};
const wave = {
  clipPath: `polygon( 0% -0%,0% -0%,0.199% 0.383%,0.818% 1.421%,1.892% 2.952%,3.455% 4.811%,5.54% 6.834%,8.182% 8.857%,11.415% 10.716%,15.273% 12.247%,19.79% 13.285%,25% 13.668%,25% 13.668%,30.333% 13.285%,35.274% 12.247%,39.943% 10.716%,44.459% 8.857%,48.941% 6.834%,53.507% 4.811%,58.277% 2.952%,63.37% 1.421%,68.905% 0.383%,75% -0%,75% -0%,80.896% 0.383%,85.812% 1.421%,89.83% 2.952%,93.038% 4.811%,95.519% 6.834%,97.359% 8.857%,98.642% 10.716%,99.453% 12.247%,99.877% 13.285%,100% 13.668%,100% 92.523%,100% 92.523%,99.851% 92.193%,99.361% 91.296%,98.46% 89.975%,97.082% 88.37%,95.159% 86.624%,92.623% 84.878%,89.407% 83.273%,85.443% 81.951%,80.663% 81.055%,75% 80.724%,75% 80.724%,69.164% 81.264%,63.831% 82.729%,58.882% 84.888%,54.199% 87.509%,49.661% 90.362%,45.151% 93.215%,40.548% 95.836%,35.735% 97.995%,30.592% 99.46%,25% 100%,25% 100%,19.557% 99.46%,14.904% 97.995%,10.992% 95.836%,7.767% 93.215%,5.18% 90.362%,3.178% 87.509%,1.711% 84.888%,0.726% 82.729%,0.173% 81.264%,0% 80.724%,0% -0% );`,
  defaultColors: [theme.colors.greyDark],
  name: 'wave',
};
const cloud = {
  clipPath: `polygon( 21.653% 45.225%,21.653% 45.225%,22.479% 37.796%,24% 30.783%,26.161% 24.272%,28.903% 18.35%,32.171% 13.102%,35.906% 8.615%,40.054% 4.975%,44.555% 2.269%,49.354% 0.582%,54.394% 0%,54.394% 0%,59.509% 0.599%,64.375% 2.337%,68.932% 5.122%,73.122% 8.866%,76.884% 13.477%,80.159% 18.866%,82.887% 24.942%,85.009% 31.615%,86.465% 38.794%,87.196% 46.391%,87.196% 46.391%,89.355% 47.615%,91.373% 49.23%,93.229% 51.206%,94.904% 53.511%,96.376% 56.115%,97.627% 58.987%,98.635% 62.097%,99.38% 65.414%,99.842% 68.906%,100% 72.544%,100% 72.544%,99.764% 76.975%,99.081% 81.178%,97.987% 85.098%,96.521% 88.678%,94.719% 91.861%,92.618% 94.591%,90.256% 96.813%,87.669% 98.47%,84.894% 99.505%,81.97% 99.862%,18.03% 99.862%,18.03% 99.862%,15.106% 99.505%,12.331% 98.47%,9.744% 96.813%,7.382% 94.591%,5.281% 91.861%,3.479% 88.678%,2.013% 85.098%,0.919% 81.178%,0.236% 76.975%,0% 72.544%,0% 72.544%,0.236% 68.112%,0.919% 63.909%,2.013% 59.989%,3.479% 56.41%,5.281% 53.227%,7.382% 50.496%,9.744% 48.274%,12.331% 46.618%,15.106% 45.583%,18.03% 45.225%,21.653% 45.225% )`,
  defaultColors: [theme.colors.greyDark],
  width: 100,
  name: 'cloud',
  height: 50,
};
const explosion = {
  clipPath: `polygon( 48.942% 1.902%,55.399% 33.587%,80.712% 13.465%,65.292% 41.888%,97.617% 42.744%,67.534% 54.605%,91.746% 76.039%,61.077% 65.789%,65.847% 97.772%,48.942% 70.206%,32.038% 97.772%,36.807% 65.789%,6.139% 76.039%,30.35% 54.605%,0.268% 42.744%,32.593% 41.888%,17.172% 13.465%,42.485% 33.587%,48.942% 1.902% );`,
  defaultColors: [theme.colors.greyDark],
  name: 'explosion',
};
const bottomWave = {
  clipPath: `
  polygon(100% 100%, 0% 100% , 0.00% 43.44%, 1.33% 45.30%, 2.67% 46.82%, 4.00% 47.96%, 5.33% 48.69%, 6.67% 48.99%, 8.00% 48.86%, 9.33% 48.31%, 10.67% 47.34%, 12.00% 45.98%, 13.33% 44.25%, 14.67% 42.20%, 16.00% 39.88%, 17.33% 37.33%, 18.67% 34.61%, 20.00% 31.79%, 21.33% 28.93%, 22.67% 26.09%, 24.00% 23.34%, 25.33% 20.74%, 26.67% 18.35%, 28.00% 16.23%, 29.33% 14.42%, 30.67% 12.96%, 32.00% 11.89%, 33.33% 11.23%, 34.67% 11.00%, 36.00% 11.20%, 37.33% 11.82%, 38.67% 12.86%, 40.00% 14.29%, 41.33% 16.07%, 42.67% 18.17%, 44.00% 20.53%, 45.33% 23.12%, 46.67% 25.86%, 48.00% 28.69%, 49.33% 31.55%, 50.67% 34.38%, 52.00% 37.11%, 53.33% 39.67%, 54.67% 42.02%, 56.00% 44.09%, 57.33% 45.85%, 58.67% 47.24%, 60.00% 48.25%, 61.33% 48.83%, 62.67% 49.00%, 64.00% 48.73%, 65.33% 48.03%, 66.67% 46.93%, 68.00% 45.44%, 69.33% 43.60%, 70.67% 41.46%, 72.00% 39.05%, 73.33% 36.44%, 74.67% 33.68%, 76.00% 30.84%, 77.33% 27.97%, 78.67% 25.16%, 80.00% 22.45%, 81.33% 19.92%, 82.67% 17.62%, 84.00% 15.59%, 85.33% 13.89%, 86.67% 12.56%, 88.00% 11.63%, 89.33% 11.11%, 90.67% 11.02%, 92.00% 11.36%, 93.33% 12.12%, 94.67% 13.29%, 96.00% 14.84%, 97.33% 16.73%, 98.67% 18.93%, 100.00% 21.37%);
  `,
  defaultColors: [theme.colors.greyDark],
  name: 'bottomWave',
  width: 1280,
  height: 100,
};
const highBottomWave = {
  clipPath: `
  polygon(100% 100%, 0% 100% , 0.00% 21.72%, 1.33% 22.65%, 2.67% 23.41%, 4.00% 23.98%, 5.33% 24.34%, 6.67% 24.50%, 8.00% 24.43%, 9.33% 24.16%, 10.67% 23.67%, 12.00% 22.99%, 13.33% 22.13%, 14.67% 21.10%, 16.00% 19.94%, 17.33% 18.66%, 18.67% 17.30%, 20.00% 15.89%, 21.33% 14.46%, 22.67% 13.04%, 24.00% 11.67%, 25.33% 10.37%, 26.67% 9.18%, 28.00% 8.12%, 29.33% 7.21%, 30.67% 6.48%, 32.00% 5.95%, 33.33% 5.62%, 34.67% 5.50%, 36.00% 5.60%, 37.33% 5.91%, 38.67% 6.43%, 40.00% 7.14%, 41.33% 8.03%, 42.67% 9.08%, 44.00% 10.27%, 45.33% 11.56%, 46.67% 12.93%, 48.00% 14.34%, 49.33% 15.78%, 50.67% 17.19%, 52.00% 18.55%, 53.33% 19.84%, 54.67% 21.01%, 56.00% 22.05%, 57.33% 22.92%, 58.67% 23.62%, 60.00% 24.12%, 61.33% 24.42%, 62.67% 24.50%, 64.00% 24.36%, 65.33% 24.02%, 66.67% 23.46%, 68.00% 22.72%, 69.33% 21.80%, 70.67% 20.73%, 72.00% 19.52%, 73.33% 18.22%, 74.67% 16.84%, 76.00% 15.42%, 77.33% 13.99%, 78.67% 12.58%, 80.00% 11.23%, 81.33% 9.96%, 82.67% 8.81%, 84.00% 7.80%, 85.33% 6.95%, 86.67% 6.28%, 88.00% 5.81%, 89.33% 5.55%, 90.67% 5.51%, 92.00% 5.68%, 93.33% 6.06%, 94.67% 6.65%, 96.00% 7.42%, 97.33% 8.37%, 98.67% 9.46%, 100.00% 10.69%);
  `,
  defaultColors: [theme.colors.greyDark],
  name: 'bottomWave',
  width: 600,
  height: 100,
};
const borderRadiusRectangleMoreRounded = {
  clipPath: 'inset(0% 0% 0% 0% round 90px)',
  defaultColors: [theme.colors.greyDark],
  name: 'borderRadiusRectangle',
};

const shapes: Shape[] = [
  circle,
  rectangle,
  borderRadiusRectangle,
  triangle,
  polygon,
  trapezoid,
  wave,
  ellipse,
  halfCircle,
  cloud,
  parallelogram,
  rhombus,
  explosion,
  pentagon,
  hexagon,
  heptagon,
  octagon,
  nonagon,
  decagon,
  bevel,
  rabbet,
  frame,
  star,
  message,
  cross,
  leftArrow,
  rightArrow,
  leftPoint,
  rightPoint,
  leftChevron,
  rightChevron,
  crossOut,
  bottomWave,
  highBottomWave,
  borderRadiusRectangleMoreRounded,
];

export default shapes;
